import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../../focus-selector.i18n';
import { Column, Row, Sort } from '../../grid/experimental.grid';
import { selectTemplate } from '../../grid/reusable-grid.function';
import { GridSortClickEvent } from '../../grid/reusable-grid.model';
import {
    ColumnID,
    FocusHistoryGrid,
} from '../../model/focus-history.grid.model';
import { FocusSelectorFocusForTeam } from '../../model/focus-selector-focus-for-team.model';

@Component({
    selector: 'closed-for-team-grid',
    templateUrl: './closed-for-team-grid.component.html',
    host: { class: 'closed-for-team-grid' },
})
export class ClosedForTeamGridComponent {
    @Input() gridData: FocusHistoryGrid<FocusSelectorFocusForTeam>;
    @Output() selectRow: EventEmitter<Row['id']>;
    @Output() sortGrid: EventEmitter<GridSortClickEvent>;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _ColumnID = ColumnID;
    /** @private */ _selectTpl = selectTemplate;

    constructor() {
        this.selectRow = new EventEmitter();
        this.sortGrid = new EventEmitter();
    }

    /** @private */ _selectRow(selectedRows: Set<Row['id']>): void {
        this.selectRow.emit(Array.from(selectedRows)[0]);
    }

    /** @private */ _getSortDef(columnId: Column['id']): Sort {
        for (const sortDef of this.gridData.sortDefs) {
            if (sortDef.columnId === columnId) {
                return sortDef;
            }
        }

        console.warn('No sortDef found for column: ', columnId);
    }
}
